export const CHECK_AUTH = "checkAuth";
export const FETCH_ALL_OFFERS = "fetchAllOffers";
export const FETCH_OFFER = "fetchOffer";
export const REGISTER_USER = "registerUser"
export const FETCH_CATEGORIES = "fetchCategories";
export const UPLOAD_OFFER = "uploadSingleOffer";
export const LOGIN_USER = "loginUser";
export const LOGOUT_USER = "logoutUser";
export const SET_UNAUTHORIZED = "setUnauthorized";
